import { useEffect, useState } from "react";
import AdminNavBar from "../../NavBar/AdminNavBar";
import TaskCard from "../../../../components/TaskCard/TaskCard";
import style from "./AllTasks.module.css";
import { Link, useParams } from "react-router";
import TaskCardLoader from "../../../../components/LoadingComponents/TaskCardLoader/TaskCardLoader";
import BreadCrumb from "../../../../components/BreadCrumb/BreadCrumb";

export default function AllTasks() {
    const [tasks, setTasks] = useState([]); // ✅ fixed: was {}
    const [error, setError] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [filter, setFilter] = useState("your");
    const [loading, setLoading] = useState(true);
    const { employeeId } = useParams();

    const token = localStorage.getItem("token");
    const apiurl = process.env.REACT_APP_SERVER_URL;
    const tasksPerPage = 6;

    useEffect(() => {
        if (!apiurl) {
            setError("API is not working");
            setLoading(false);
            return;
        }

        fetch(`${apiurl}/tasks/all-tasks`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
            .then((res) => res.json())
            .then((d) => {
                setLoading(false);
                // ✅ safeguard if API doesn't return an array
                setTasks(Array.isArray(d.tasks) ? d.tasks : []);
            })
            .catch((error) => {
                setLoading(false);
                setError(error.message);
            });
    }, [apiurl, token]);

    // Filter tasks
    const filteredTasks =
        filter === "your"
            ? tasks.filter((t) => t.assignedBy === employeeId)
            : tasks;

    // Pagination
    const indexOfLastTask = currentPage * tasksPerPage;
    const indexOfFirstTask = indexOfLastTask - tasksPerPage;
    const currentTasks = filteredTasks.slice(indexOfFirstTask, indexOfLastTask);
    const totalPages = Math.ceil(filteredTasks.length / tasksPerPage) || 1;

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
    };

    const handlePrev = () => {
        if (currentPage > 1) setCurrentPage((prev) => prev - 1);
    };

    return (
        <>
            <div className="container pt-lg-2">
                <div className={`${style.taskPage}`}>
                    <AdminNavBar />

                    {/* error component */}
                    {error && <p className="text-danger">{error}</p>}

                    <div className="row mb-3">
                        {/* BreadCrumb Linkss */}
                        <div className="col-8 col-sm-8 col-lg-5 ps-sm-4 ps-lg-5">
                            <BreadCrumb
                                link={`/admin-dashboard/${employeeId}`}
                                name="Dashboard"
                                icon={true}
                            />
                            <BreadCrumb
                                link={`/admin-dashboard/${employeeId}/all-tasks`}
                                name="All Tasks"
                            />
                        </div>

                        {/* total tasks length */}
                        <div className="col-4 col-sm-4 mt-2 d-lg-none">
                            <p className={style.breadcrumb}>
                                Tasks: <b>{filteredTasks.length}</b>
                            </p>
                        </div>

                        {/* dummy component for ui purpose */}
                        <div className="col-lg-2 "></div>

                        {/* filter section fo your and all tasks */}
                        <div className="col-4 col-sm-6 col-lg-2 text-end">
                            <select
                                className="form-select form-select-sm w-auto d-inline-block"
                                value={filter}
                                onChange={(e) => {
                                    setFilter(e.target.value);
                                    setCurrentPage(1);
                                }}
                            >
                                <option value="your">Your Tasks</option>
                                <option value="all">All Tasks</option>
                            </select>
                        </div>

                        {/* create task button */}
                        <div className="col-8 col-sm-6 text-center col-lg-2">
                            <Link
                                style={{ textDecoration: "none" }}
                                className={`${style.newProject} ps-2 pe-2 rounded bg-light`}
                                to={`/admin-dashboard/${employeeId}/all-tasks/create-task`}
                            >
                                + Create Task
                            </Link>
                        </div>

                        {/* /tasks length */}
                        <div className="d-none d-sm-block d-lg-block col-lg-1 mt-lg-1">
                            <p className={style.link}>
                                Tasks: <b>{filteredTasks.length}</b>
                            </p>
                        </div>
                    </div>

                    {/* Grid layout for containing the taks loader and task card*/}
                    <div className="row g-4 ps-3 pe-3">
                        {loading ? (
                            <>
                                {Array.from({ length: 6 }).map((_, i) => (
                                    <div className="col-lg-6" key={i}>
                                        <TaskCardLoader />
                                    </div>
                                ))}
                            </>
                        ) : (
                            <>
                                {currentTasks.length > 0 ? (
                                    currentTasks.map((task, index) => (
                                        <div className="col-lg-6" key={index}>
                                            <Link
                                                to={`/admin-dashboard/${employeeId}/all-tasks/${task._id}`}
                                                style={{
                                                    textDecoration: "none",
                                                    color: "inherit",
                                                }}
                                            >
                                                <TaskCard
                                                    title={task.title}
                                                    assignedBy={task.assignedBy}
                                                    status={task.status}
                                                    finishingDate={task.finishingDate}
                                                    finishingTime={task.finishingTime}
                                                    priority={task.priority}
                                                    preferences={task.preferences}
                                                    assignedFor={
                                                        Array.isArray(task.employeeId)
                                                            ? task.employeeId.join(", ")
                                                            : task.employeeId
                                                    }
                                                />
                                            </Link>
                                        </div>
                                    ))
                                ) : (
                                    <p className="text-center text-muted">
                                        No tasks found.
                                    </p>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Pagination */}
            <div className="row mt-4 mb-4">
                <div className="col-12 text-center">
                    <button
                        style={{ border: "none" }}
                        className="btn mx-2"
                        onClick={handlePrev}
                        disabled={currentPage === 1}
                    >
                        <b>{"<<"}</b>
                    </button>
                    <span className="mx-2">
                        Page {currentPage} of {totalPages}
                    </span>
                    <button
                        style={{ border: "none" }}
                        className="btn mx-2"
                        onClick={handleNext}
                        disabled={currentPage === totalPages}
                    >
                        <b>{">>"}</b>
                    </button>
                </div>
            </div>
        </>
    );
}
